import { call, put, select, takeLatest } from "redux-saga/effects";
import { FETCH_SPOT_CONTACTS_BC_PSYCO_REQUEST, FETCH_SPOT_CONTACTS_BC_REQUEST, FetchSpotContactsBCFailure, FetchSpotContactsBCPsycoFailure, FetchSpotContactsBCPsycoSuccess, FetchSpotContactsBCSuccess } from "../../actions/targetedReachout/spotContactBattleCardActions";
import { getContactPsycoMetricData, spotContactBC } from "../../../../services/iqApiV2";




// Worker Saga
function* fetchspotContactBCSaga() {
  try {
    const payload = yield select(
      (state) => state?.spotContactBCReducer?.payload
    );
    const { contactId } = payload;
    const data = yield call(
        spotContactBC,
        contactId
    ); 
    yield put(FetchSpotContactsBCSuccess(data));
  } catch (error) {
    yield put(FetchSpotContactsBCFailure(error.message));
  }
}

// Watcher Saga
export function* watchspotContactBCSaga() {
  yield takeLatest(FETCH_SPOT_CONTACTS_BC_REQUEST, fetchspotContactBCSaga);

}





//FETCH_SPOT_CONTACTS_BC_PSYCO_REQUEST


function* fetchContactPsycoMetricData() {
  try {
    const payload = yield select(
      (state) => state?.spotContactBCPsycoReducer?.payload
    );
    const { contactId } = payload;
    const data = yield call(
        getContactPsycoMetricData,
        contactId
    );
    yield put(FetchSpotContactsBCPsycoSuccess(data));
  } catch (error) {
    yield put(FetchSpotContactsBCPsycoFailure(error.message));
  }
}

// Watcher Saga
export function* watchspotContactPsycoSaga() {
  yield takeLatest(FETCH_SPOT_CONTACTS_BC_PSYCO_REQUEST, fetchContactPsycoMetricData);

}
